const RootPath = window.g.baseUrl
const apis = {
  // 公共api
  login: RootPath + 'plugin/authority/default/login',
  logout: RootPath + 'plugin/authority/default/logout',
  updatePsw: RootPath + 'plugin/authority/default/updatePsw',
  uploadImage: RootPath + 'plugin/generic/upload/uploadImage',
  uploadFiles: RootPath + 'plugin/generic/upload/uploadFiles',
  delFiles: RootPath + 'plugin/generic/default/delFiles'
}

export default apis
